export default __webpack_public_path__ + "static/mapExample1-0ead045b227cba922e8bb7f66475cf58.png";